"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
require("./style.css");
var utils_1 = require("../utils");
exports.CustomButton = function (_a) {
    var render = _a.render, name = _a.name, configTooltip = _a.tooltip, editor = _a.editor;
    var renderContent = function () { return render(editor); };
    var localeTip = editor.configurator.getLocaleValue(name).tooltip;
    var tooltip = configTooltip || localeTip;
    return (react_1.default.createElement("div", { className: 'syl-toolbar-tool custom ' + (name || '') }, tooltip ? (react_1.default.createElement(utils_1.Tooltip, { content: tooltip }, renderContent())) : (renderContent())));
};
//# sourceMappingURL=index.js.map